import _getters_links from './_getters/links.js'
import _getters_items from './_getters/items.js'
import state from './state.js'

export default {
    namespaced: true,
    state,
    getters:{
        items: _getters_items,
        links: _getters_links,
    },
}